import { Input } from '../../ui/input';

export const BasicInfoStep = ({ formData, update, updateEC }) => (
  <div className="space-y-5" data-testid="intake-step-basic">
    <h2 className="text-2xl font-bold text-darkBrown mb-2">Basic Information</h2>
    <div className="grid md:grid-cols-2 gap-4">
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">First Name *</label>
        <Input data-testid="intake-firstName" value={formData.firstName} onChange={(e) => update('firstName', e.target.value)} placeholder="First Name" required />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Last Name *</label>
        <Input data-testid="intake-lastName" value={formData.lastName} onChange={(e) => update('lastName', e.target.value)} placeholder="Last Name" required />
      </div>
    </div>
    <div className="grid md:grid-cols-2 gap-4">
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Date of Birth *</label>
        <Input data-testid="intake-dob" type="date" value={formData.dateOfBirth} onChange={(e) => update('dateOfBirth', e.target.value)} required />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Gender *</label>
        <select data-testid="intake-gender" className="flex h-10 w-full rounded-md border border-gray-300 bg-background px-3 py-2 text-sm" value={formData.gender} onChange={(e) => update('gender', e.target.value)}>
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="non-binary">Non-Binary</option>
          <option value="prefer-not-to-say">Prefer Not to Say</option>
        </select>
      </div>
    </div>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Street Address</label>
      <Input data-testid="intake-address" value={formData.address} onChange={(e) => update('address', e.target.value)} placeholder="123 Main St" />
    </div>
    <div className="grid md:grid-cols-3 gap-4">
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">City</label>
        <Input value={formData.city} onChange={(e) => update('city', e.target.value)} placeholder="City" />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">State</label>
        <Input value={formData.state} onChange={(e) => update('state', e.target.value)} placeholder="TX" />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Zip Code</label>
        <Input value={formData.zipCode} onChange={(e) => update('zipCode', e.target.value)} placeholder="77338" />
      </div>
    </div>
    <div className="grid md:grid-cols-2 gap-4">
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Phone *</label>
        <Input data-testid="intake-phone" type="tel" value={formData.phone} onChange={(e) => update('phone', e.target.value)} placeholder="(555) 123-4567" required />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Email *</label>
        <Input data-testid="intake-email" type="email" value={formData.email} onChange={(e) => update('email', e.target.value)} placeholder="email@example.com" required />
      </div>
    </div>
    <h3 className="text-lg font-semibold text-darkBrown pt-4 border-t">Emergency Contact</h3>
    <div className="grid md:grid-cols-3 gap-4">
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Name</label>
        <Input value={formData.emergencyContact.name} onChange={(e) => updateEC('name', e.target.value)} placeholder="Contact Name" />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Phone</label>
        <Input type="tel" value={formData.emergencyContact.phone} onChange={(e) => updateEC('phone', e.target.value)} placeholder="Phone" />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Relationship</label>
        <Input value={formData.emergencyContact.relationship} onChange={(e) => updateEC('relationship', e.target.value)} placeholder="Spouse, Parent..." />
      </div>
    </div>
  </div>
);
